export default __webpack_public_path__ + "static/media/icon_search.bee89322.svg";